module.exports = __webpack_public_path__ + "static/media/logo.a1321114.svg";